// extracted by mini-css-extract-plugin
var _1 = "Tab-moduleTab__yRe6s";
var _2 = "Tab-moduleactive__aJHYf";
var _3 = "Tab-modulecount__TwaYr";
var _4 = "Tab-modulecountSkeleton__lVm7m Skeleton-moduleSkeleton__Mlrfv";
var _5 = "Tab-moduledisabled__q232a";
var _6 = "Tab-moduletext__MvSq2";
export { _1 as "Tab", _2 as "active", _3 as "count", _4 as "countSkeleton", _5 as "disabled", _6 as "text" }
